import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { PatientRehabImpMarkets } from '../../../interfaces/masters/patient-rehab-imp-markets';

@Injectable()
export class PatientRehabImpMarketsApi {
    private readonly apiController: string = '';

    constructor(private api: HttpService) { } 
     
    list(url: string, options?: any): Observable<any[]> {      
        const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
        return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
      }
    
      getById(url : string, options?: any): Observable<PatientRehabImpMarkets> {
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.directGet(url,header);
      }
    
      add(url:string, data: PatientRehabImpMarkets):Observable<PatientRehabImpMarkets>{
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.post( url, data, header);
      }
    
      update(url:string, data: PatientRehabImpMarkets):Observable<any>{
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
      }
    
      delete(url: string):Observable<any>{        
        return this.api.directDelete(url);
      } 
}
